const styles = (theme) => ({
  root: {
    ...theme.mixins.modal.dialog.root,
  },
  title: {
    fontWeight: theme.typography.fontWeightMedium,
  },
});

export default styles;
